<template>
  <div
    class="course"
  >
    <div
      v-show="isShowPage"
      :style="{background: course.indexMainHue}"
    >
      <CoolMTopbar :downUrl="bookContent.openUrl"/>
      <courseTopMsg
        :courseMsg='course'
      />
      <!-- tab -->
      <div
        :class="[isHasBorder ? 'course__noBorder': '' ,'course__tabList']"
        id='courseSticky'
      >
        <div
          :class="['course__tab', introduction ? 'course__tabCheck' : '']"
          v-fastclick="() => checkTab('introduction')"
          v-log:click.ev__course_detail_view="{
            'view_position': page_name,
            'course_id': coursePid,
            'course_name': title,
            'course_type': '视频课程',
            'is_bought': '无法确定',
            'tab_name': '简介',
          }"
        >简介</div>
        <div
          :class="['course__tab', catalog ? 'course__tabCheck': '']"
          v-fastclick="() => checkTab('catalog')"
          v-log:click.ev__course_detail_view="{
            'view_position': page_name,
            'course_id': coursePid,
            'course_name': title,
            'course_type': '视频课程',
            'is_bought': '无法确定',
            'tab_name': '目录',
          }"
        >目录</div>
        <div
          v-if="Object.keys(recommendConfig).length!=0 || recommendConfig.jsonInfo"
          :class="['course__tab', recommend ? 'course__tabCheck': '']"
          v-fastclick="() => checkTab('recommend')"
          v-log:click.ev__course_detail_view="{
            'view_position': page_name,
            'course_id': coursePid,
            'course_name': title,
            'course_type': '视频课程',
            'is_bought': '无法确定',
            'tab_name': '推荐',
          }"
        >推荐</div>
      </div>
      <!-- 课程banner -->
      <course-banner v-if="course.coursePid" :coursePid="course.coursePid" courseType="3"/>
      <!-- 简介 -->
      <div class="course__introContanier" v-show="introduction">
        <!-- 介绍 -->
        <div :class="!isShowIntroAll ? 'course__introductionLimit': 'course__introduction'">
          <div class="course__introCover" v-for="(item, index) in course.courseIntroduction" :key='index'>
            <img v-if="item.type == 'image'" class="course__introImage" :src="item.content" @click="jumpToContentHref(item.linkUrl)">
            <div v-if="item.type == 'text'" class="course__introText" v-html="item.content"></div>
            <div v-if="item.type === 'video'" class="video__wrapper">
              <video
                :controls='true'
                preload
                @play='playVideo(item)'
                :poster='item.coverIndexUrl'
                class='trainingTask__video'
                playsinline
                :webkit-playsinline='true'
                style="display: inline"
                ref="video"
              >
                <source :src="item.content" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="course__introAll" v-show="!isShowIntroAll">
            <div class="course__introLayer"></div>
            <div class="course__openAll" v-fastclick='() => openAllIntro()'>展开全部 </div>
          </div>
        </div>
        <!-- 课程大纲 -->
        <div class="course__outline">课程大纲<span class="course__grayColor">（共{{course.courseNumber}}讲）</span></div>
        <div class="course__introductionLimit2" v-fastclick='() => openEnlarge()'>
          <div class="course__introCover">
            <img class="course__introImage" :src="course.courseMiniImageUrlNew">
          </div>
          <div class="course__enlarge">
            <img src="//coolcdn.igetcool.com/t/2020/2/2868166bc8b30039eac1572f671741f5ae.png" alt="放大镜">
          </div>
        </div>
        <!-- 留言 -->
        <div class="course__leaveMsg" v-show="course.commentList && course.commentList.length > 0">
          <div class="course__outline">精选留言</div>
          <div
            class="course__messageNum"
            v-fastclick='() => jumpToAllComment()'
            v-log:click="{page_name, title, product_name: title, product_id, h5_type, element_name: '跳转留言页面内'}"
          >
            <div>{{course.siftCommentCount}}条</div>
            <div class="course__messageArrow"></div>
          </div>
        </div>
        <div class="course__leaveMsgContent" v-for="(item, index) in course.commentList" :key='index'>
          <div class="course__avatr">
            <img :src="item.userHeadUrl" >
          </div>
          <div class="course__content">
            <div class="course__leaveTop">
              <div class="course__name">{{item.nickName}}</div>
            </div>
            <div class="course__contentText">{{item.commentContent}}</div>
            <p class="course__time">{{item.commentCreateTime}}</p>
          </div>
        </div>
        <div class="course__noMessage" v-show="course.commentList &&course.commentList.length == 0">
          <div class="course__outline">精选留言</div>
          <img class="course__noMessageImg" src="//coolcdn.igetcool.com/t/2020/1/14ef11eb853ebbba1665fa5c1a8a7704c0.png">
          <p class="course__noMessageText">暂无精选留言</p>
        </div>
        <!-- 购买须知 -->
        <div class="course__outline" v-show="course.courseMustKnow">购买须知</div>
        <div class="course__knowContent course__knowText" v-html="course.courseMustKnow">
          <!-- <p class="course__knowText">{{this.course.courseMustKnow}}</p> -->
        </div>
      </div>
      <!-- 目录 -->
      <div
        v-show="catalog"
        class="course__whiteBackground"
      >
        <div class="course__listTop">
          <div class="course__number">共{{course.courseNumber}}讲/已更新{{course.courseNumberNow}}讲</div>
          <!-- <div class="course__order" v-fastclick='() => controlOrder()'>
            <div class="course__sort"></div>
            <span v-show="catalogOrder">正序</span>
            <span v-show="!catalogOrder">倒序</span>
          </div> -->
        </div>
        <div class="course__videoList">
          <div v-if="isShowListVideo">
            <div v-for="(item, index) in videoObj" :key="index" class="course__videoListLine">
              <div class="course__listTitle">{{item[0].sectionTitle}}</div>
              <div
                class="course__diversity"
                v-for="(ele, number) in item"
                :key="number"
                v-fastclick='() => jumpToSingle(ele)'
                v-log:click.ev__course_detail_play="{
                  course_id: coursePid,
                  course_name: title,
                  course_type: '视频课程',
                  teacher_name: course.tellerInfo,
                  chapter_id: ele.videoPid,
                  chapter_name: ele.videoTitle,
                  chapter_duration: convertSecond(ele.videoTimeLen),
                  free_chapter_status: ele.free === 1 ? '是' : '否',
                  learning_status: '开始播放',
                  is_bought: '无法确定',
            }"
              >
                <div class="course__imgCover">
                  <img :src="ele.videoImageUrl">
                  <div class="course__imgLayer"></div>
                  <div class="course__tryTips" v-show="ele.free"></div>
                  <span class="course__videoLength">{{ele.videoTimeLen}}</span>
                </div>
                <div class="course__videoMsg">
                  <div class="course__videoName">{{ele.videoTitle}}</div>
                  <div class="course__videoStudyNum">{{ele.videoStudyCountCopy}}</div>
                  <!-- 锁 -->
                  <div class="course__lock" v-if="ele.free != 1"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 没有目录显示的视频列表 -->
          <div v-if="!isShowListVideo">
            <div
              class="course__diversity"
              v-for="(ele, number) in videoList"
              :key="number"
              v-fastclick='() => jumpToSingle(ele)'
              v-log:click.ev__course_detail_play="{
              course_id: coursePid,
              course_name: title,
              course_type: '视频课程',
              teacher_name: course.tellerInfo,
              chapter_id: ele.videoPid,
              chapter_name: ele.videoTitle,
              chapter_duration: convertSecond(ele.videoTimeLen),
              free_chapter_status: ele.free === 1 ? '是' : '否',
              learning_status: '开始播放',
              is_bought: '无法确定',
            }"
            >
              <div class="course__imgCover">
                <img :src="ele.videoImageUrl">
                <div class="course__imgLayer"></div>
                <div class="course__tryTips" v-show="ele.free"></div>
                <span class="course__videoLength">{{ele.videoTimeLen}}</span>
              </div>
              <div class="course__videoMsg">
                <div class="course__videoName">{{ele.videoTitle}}</div>
                <div class="course__videoStudyNum">{{ele.videoStudyCountCopy}}</div>
                <!-- 锁 -->
                <div class="course__lock" v-if="ele.free != 1"></div>
              </div>
            </div>
          </div>

        </div>
        <!-- 目录底部 -->
        <div class="course__bottomTips">{{this.course.videoUpdateInfo}}</div>
      </div>
      <!-- 推荐 -->
      <div class="recommend-list" v-show="recommend" >
        <recommend-list-cpn :configInfo="recommendConfig" :configID="configID" ></recommend-list-cpn>
      </div>
      <!-- 底部 -->
      <courseButton
        :price='course.coursePrice'
        :routerPath='bookContent.openUrl'
        :product_id='coursePid'
        :title="title"
        page_name='视频详情页'
        h5_type='视频详情页'
        buttonName='试看'
        @tryListen="tryListen"
        :evLogTrack="evLogTrackValue"
      />
    </div>
    <div class="course__layer" v-show="isShowLayer" v-fastclick='() => openEnlarge()'>
      <img class="course__introImage" :src="course.courseOutline">
    </div>
    <div v-show="!isShowPage">
      <Skeleton
        :fixCenter='true'
      />
    </div>
  </div>
</template>
<script>
import { courseMixin } from '@/mixins/courseMixin.js';
import Skeleton from './../../components/skeleton';
import { JS2Native, env, httpRequest, href, webSDK, LogTrack } from '../../utils';
import { fetchShareInfo } from '../../utils/share';
import { CoolMTopbar } from '@igetcool/cool-mobile-ui';

import courseButton from '../../components/courseButton';
import courseTopMsg from '../../components/courseTopMsg';
import { log } from 'util';
import CourseBanner from '@/components/CourseBanner';
import recommendListCpn from './recommendList.vue';
import { getOperateActivityInfo, SUCCESS_CODE } from '../operateActivityV2/server';

const baseURL = '/app-api-course-server/';

export default {
  mixins: [courseMixin],
  components: {
    CoolMTopbar,
    courseButton,
    courseTopMsg,
    Skeleton,
    CourseBanner,
    recommendListCpn
  },
  data() {
    return {
      catalog: false,
      recommend: false,
      introduction: true,
      isApp: env.isApp,
      audioPid: this.$route.query.audioPid,
      bookContent: {},
      isShowPage: false,
      course: {},
      isShowIntroAll: false,
      shareType: 1,
      shareRelaPid: this.$route.query.audioPid || '',
      coursePid: this.$route.query.audioPid || '',
      recommendList: [],
      videoList: [],
      // catalogOrder: true,
      videoObj: {},
      recommendFlag: 1,
      title: '',
      page_name: '点播课详情页',
      h5_type: '点播课详情页',
      product_id: '',
      product_name: '',
      tabTop: '',
      isHasBorder: false,
      isShowListVideo: true,
      evLogTrackValue: {},
      isShowLayer: false,
      recommendConfig: {},
      configID: '',
    };
  },
  mounted() {
    webSDK.init();
    this.getOpenURL();
    this.getCourse();
    this.getRecommend();
    this.setShareInfo();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    playVideo(item) {
      let video = this.$refs.video;
      let videoArr = [];
      for (let i = 0; i < this.course.courseIntroduction.length; i++) {
        if (this.course.courseIntroduction[i].type == 'video') {
          videoArr.push(this.course.courseIntroduction[i]);
        }
      }
      for (let i = 0; i < videoArr.length; i++) {
        if (videoArr[i].content != item.content) {
          video[i].pause();
        }
      }
      this.logTrackVideoPlay();
    },
    openEnlarge() {
      this.isShowLayer = !this.isShowLayer;
      this.isShowLayer && this.handleStopAllVideo();
    },
    handleScroll() {
      let scrollTop = document.getElementById('courseSticky').offsetTop;
      if (scrollTop != this.tabTop) {
        this.tabTop = scrollTop;
        this.isHasBorder = true;
      } else {
        this.isHasBorder = false;
      }
    },
    setShareInfo() {
      fetchShareInfo({
        shareId: this.shareRelaPid,
        shareType: this.shareType
      }).then(data => {
        const { shareTitle, shareUrl, shareIntro, shareCover } = data;
        webSDK.setShare({
          title: shareTitle,
          link: shareUrl || window.location.href,
          desc: shareIntro,
          imgUrl: shareCover
        });
      });
    },
    jumpToSingle(item) {
      if (item.free) {
        this.$router.push({
          path: '/courseSingleVideo',
          query: {
            videoPid: item.videoPid,
            coursePid: item.coursePid,
            openUrl: this.bookContent.openUrl
          }
        });
      } else {
        webSDK.openApp(this.bookContent.openUrl);
      }
    },
    convertSecond(videoTimeLen) {
      let l = videoTimeLen.split(':');
      let result = Number(l[1]) * 60 + Number(l[2]);
      return result;
    },


    // @aigc:start 2024-06-13-16:59
    /**
     * 获取推荐课程列表的接口
     * @param {activityId} 运营活动id
     */

    async getConfigDetailRequest() {
      const query = { activityId: this.configID };
      try {
        const { code, data, msg } = await getOperateActivityInfo(query);
        if (code === SUCCESS_CODE) {
          this.recommendConfig = data;
        } else {
          this.$coolToast({
            text: msg
          });
        }
      } catch (error) {
      } finally {
        this.$coolSkeleton.hide();
        if (env.isApp) {
          setTimeout(() => {
            JS2Native({
              name: 'closeAppLoading'
            });
          }, 200);
        }
      }
    },

    // 根据课程id 获取 活动页id ，拿到 活动页id 后获取推荐课程列表的数据进行渲染
    getRecommend() {
      httpRequest
        .get('activity-course-server/api/activity/course/detail/recommend/get', {
          courseId: this.coursePid,
          sourceType: 2, // 1:站内 2:站外
        })
        .then(res => {
          if (res.data && res.data.h5ActivityPageId) {
            this.configID = res.data.h5ActivityPageId;
            this.getConfigDetailRequest();
          }
        }).catch();
    },
    // @aigc:end 2024-06-13-16:59


    getEvLogTrack() {
      this.evLogTrackValue = {
        course_id: this.coursePid,
        course_name: this.title,
        course_type: '视频课程',
        teacher_name: this.course.tellerInfo,
        chapter_id: this.videoList[0].videoPid,
        chapter_name: this.videoList[0].videoTitle,
        chapter_duration: this.convertSecond(this.videoList[0].videoTimeLen),
        free_chapter_status: this.videoList[0].free === 1 ? '是' : '否',
        learning_status: '开始播放',
        is_bought: '无法确定',
      };
    },
    // controlOrder () {
    //   // this.videoObj.reverse()
    //   console.log(this.videoObj)
    //   this.videoObj['-1'].reverse()
    //   this.catalogOrder = !this.catalogOrder
    // },
    // 详情视频show埋点
    logTrackVideoShow() {
      LogTrack.track({
        'page_name': '视频课程详情页',
        'page_type': 2,
        'page_title': this.coursePid,
        'url': window.location.href,
        'main_item_id': this.coursePid,
        'main_item_type': '视频课',
        'module_name ': '简介',
        'item_name': '视频',
      }, 'show');
    },
    // 详情视频播放埋点
    logTrackVideoPlay() {
      LogTrack.track({
        'page_name': '视频课程详情页',
        'page_type': 2,
        'page_title': this.coursePid,
        'url': window.location.href,
        'main_item_id': this.coursePid,
        'main_item_type': '视频课',
        'module_name ': '简介',
        'item_name': '视频',
        'btn_name': '播放'
      }, 'click');
    },
    // 页面浏览埋点
    logTrackView() {
      LogTrack.track({
        'view_position': this.page_name,
        'course_id': this.coursePid,
        'course_name': this.title,
        'course_type': '视频课程',
        'is_bought': '无法确定',
        'tab_name': '简介',
        '__ev_track_name': 'course_detail_view',
      }, 'course_detail_view');
    },
    openAllIntro() {
      this.isShowIntroAll = true;
    },
    checkTab(name) {
      switch (name) {
        case 'introduction':
          this.catalog = false;
          this.recommend = false;
          this.introduction = true;
          break;
        case 'catalog':
          // 点击试看，所有简介视频暂停
          this.handleStopAllVideo();
          this.catalog = true;
          this.recommend = false;
          this.introduction = false;
          break;
        case 'recommend':
          // 点击试看，所有简介视频暂停
          this.handleStopAllVideo();
          this.catalog = false;
          this.recommend = true;
          this.introduction = false;
          break;
      }
    },
    jumpToAllComment() {
      this.$router.push({
        path: '/allComment',
        query: {
          modulePid: this.coursePid,
          sourceLink: encodeURI(window.location.href),
          shareType: this.shareType,
          shareRelaPid: this.shareRelaPid,
          type: 'bunch'
        }
      });
    },
    // 暂停所有的视频
    handleStopAllVideo() {
      let video = this.$refs.video;
      if (!video) {
        return;
      }
      for (let i = 0; i < video.length; i++) {
        video[i].pause();
      }
    },
    tryListen() {
      // 点击试看，所有简介视频暂停
      this.handleStopAllVideo();

      this.checkTab('catalog');
      // let data = this.videoObj[Object.keys(this.videoObj)[0]][0]
      let arr1 = Object.keys(this.videoObj);
      let obj = this.videoObj;
      let arr = [];
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr1[i].length; j++) {
          if (obj[arr1[i]][j]) {
            arr.push(obj[arr1[i]][j]);
          }
        }
      }

      let videoPid = '';
      let coursePid = '';
      let isFree = true;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].free == 1 && isFree) {
          videoPid = arr[i].videoPid;
          coursePid = arr[i].coursePid;
          isFree = false;
        }
      }


      this.$router.push({
        path: '/courseSingleVideo',
        query: {
          videoPid: videoPid,
          coursePid: coursePid,
          openUrl: this.bookContent.openUrl
        }
      });
    },
    getOpenURL() {
      httpRequest
        .get(baseURL + 'white/share/course.json', {
          coursePid: this.audioPid
        })
        .then(res => {
          if (res.code === 10000) {
            this.bookContent = res.data;
          }
        });
    },
    getCourse() {
      httpRequest
        .get(baseURL + 'option/course.json',
          {
            audioPid: this.audioPid,
            intro: this.$route.query.intro,
            t: 3
          }, {
            headers: { 'App-Version': '4.18.0' },
          })
        .then(res => {
          if (res.code !== 10000) {
            return;
          }
          if (!res.data) {
            data = {};
          }
          this.course = res.data;
          this.coursePid = this.course.coursePid;
          this.title = this.course.courseTitle;
          this.videoList = this.course.videos;
          this.recommendFlag = this.course.recommendFlag;
          this.course.courseMustKnow = '&nbsp;&nbsp;&nbsp;&nbsp;' + this.course.courseMustKnow.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;');
          this.assembleVideo();
          this.isShowPage = true;

          // 页面浏览埋点
          this.logTrackView();
          this.getEvLogTrack();
          // 详情视频show埋点
          this.logTrackVideoShow();
        });
    },
    assembleVideo() {
      if (!this.videoList) {
        this.videoList = [];
      }
      for (let i = 0; i < this.videoList.length; i++) {
        let sectionPid = this.videoList[i].sectionPid;
        if (this.videoObj[sectionPid]) {
          this.videoObj[sectionPid].push(this.videoList[i]);
        } else {
          this.videoObj[sectionPid] = [this.videoList[i]];
        }
      }
      let checkVideo = Object.keys(this.videoObj);
      for (let i = 0; i < checkVideo.length; i++) {
        if (checkVideo[i] == '-1') {
          this.isShowListVideo = false;
          return;
        }
      }
    },
    checkFrame(productId) {
      this.recommendList.map((item, index) => {
        if (productId == item.productId) {
          item.checked = !item.checked;
          this.$forceUpdate();
        }
      });
    },
    // 课程图片跳转
    jumpToContentHref(url) {
      this.$coolHref(url);
    },
  }
};
</script>
<style lang="scss" scoped>
  .course {

    &__layer {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 12;
      overflow-y: scroll;
    }

    &__enlarge {
      width: .24rem;
      height: .24rem;
      position: absolute;
      bottom: .1rem;
      right: .1rem;

      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }

    &__knowContent {
      padding-bottom: .5rem;
    }

    &__videoListLine {
      padding-bottom: .1rem;
    }

    &__videoMsg {
      position: relative;
      flex: 1;
    }

    &__lock {
      width: .24rem;
      height: .24rem;
      position: absolute;
      right: 0;
      bottom: .05rem;
      background-image: url(//coolcdn.igetcool.com/p/2020/1/2b61687c7de8974fc53bd8e7a3614c37d.svg);
      background-repeat: no-repeat;
      background-size: contain;
      // background-color: rgba(161, 161, 179, .1);
      color: rgba(161, 161, 179, .1);
    }

    &__whiteBackground {
      background: #fff;
      padding-bottom: .6rem;
    }

    &__introContanier {
      padding-bottom: 1.1rem;
      background: #fff;
    }

    &__videoStudyNum {
      color: #6D6D80;
      font-size: .12rem;
    }

    &__frame {
      position: absolute;
      top: .48rem;
      right: 0;
    }

    &__noCheckFrame {
      width: .24rem;
      height: .24rem;
      background: url(//coolcdn.igetcool.com/p/2020/1/3936f78902a1a8c802b1851fddc8fcb6c.png) no-repeat;
      background-size: 100% auto;
    }

    &__checkFrame {
      width: .24rem;
      height: .24rem;
      background: url(//coolcdn.igetcool.com/p/2020/1/33d64ac338241890b62b749fdc55516cd.png) no-repeat;
      background-size: 100% auto;
    }

    &__recommendPrice {
      font-size: .16rem;
      color: #6D6D80;
      font-family: Oswald-Medium;
    }

    &__unit {
      color: #6D6D80;
      font-size: .12rem;
      font-family: Oswald-Medium;
    }

    &__author {
      color: #A1A1B3;
      font-size: .13rem;
      margin-bottom: .15rem;
    }

    &__recommendDesc {
      color: #6C6C80;
      font-size: .13rem;
      margin-bottom: .04rem;
    }

    &__recommendContent {
      padding-top: .1rem;
      margin-bottom: .06rem;
    }

    &__recommendTitle {
      color: #41414D;
      font-size: .16rem;
      font-family: Oswald-Medium;
    }

    &__recommendImage {
      width: .9rem;
      height: 1.2rem;
      margin-right: .18rem;

      img {
        width: 100%;
        vertical-align: top;
      }
    }

    &__recommendList {
      display: flex;
      width: 3.35rem;
      margin: 0 auto;
      padding-top: .1rem;
      padding-bottom: .1rem;
      position: relative;
    }

    &__clounm {
      display: flex;
      flex-direction: column;
    }

    &__bottomBg {
      background: #fff;
      flex: 1;
      // overflow: hidden;
      border-top-right-radius: .16rem;
      border-top-left-radius: .16rem;
    }

    &__noRecommend {
      padding-top: 1.2rem;
    }

    &__recommend {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fff;
      padding-bottom: .6rem;
    }

    &__videoName {
      color: #41414D;
      font-size: .16rem;
      padding-top: .06rem;
      margin-bottom: .1rem;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2;
    }

    &__imgLayer {
      position: absolute;
      left: 0;
      top: 0;
      width: 1.5rem;
      height: .84rem;
      border-radius: .08rem;
      overflow: hidden;
      background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(0,0,0,0.3) 100%);
    }

    &__videoLength {
      color: #fff;
      font-size: .12rem;
      position: absolute;
      right: .04rem;
      bottom: .02rem;
    }

    &__diversity {
      display: flex;
      padding: .1rem .2rem;
      background: #fff;
    }

    &__imgCover {
      position: relative;
      width: 1.5rem;
      margin-right: .15rem;
      height: .84rem;

      img {
        width: 1.5rem;
        height: .84rem;
        display: block;
        border-radius: .08rem;
        overflow: hidden;
      }
    }

    &__tryTips {
      width: .32rem;
      height: .18rem;
      position: absolute;
      bottom: .08rem;
      left: -.04rem;
      background: url(//coolcdn.igetcool.com/p/2020/1/7220ebbc9e18feecfe82595cf065aedab.png) no-repeat;
      background-size: 100% auto;
    }

    &__listTitle::before {
      content: ' ';
      background: #FF5F2E;
      width: .03rem;
      height: .12rem;
      position: absolute;
      left: .2rem;
      top: .12rem;
      border-radius: .02rem;
    }

    &__listTitle {
      background: #FAFAFC;
      position: relative;
      color: #41414D;
      font-size: .14rem;
      height: .36rem;
      line-height: .36rem;
      padding-left: .27rem;
      margin-bottom: .1rem;
    }

    // 简介
    &__time {
      color: #A1A1B3;
      font-size: .12rem;
    }

    &__bottomTips {
      margin-top: .3rem;
      color: #A1A1B3;
      font-size: .14rem;
      text-align: center;
      padding-bottom: .3rem;
    }

    &__content {
      width: 2.8rem;
    }

    &__contentText {
      color: #41414D;
      font-size: .15rem;
      line-height: .24rem;
      margin-bottom: .08rem;
    }

    &__leaveList {
      display: flex;
      padding-top: .15rem;
    }

    &__zanContent {
      display: flex;
    }

    &__leaveTop {
      display: flex;
      flex: 1;
      margin-bottom: .06rem;
    }

    &__zanNumber {
      font-size: .14rem;
      color: #FF5F2E;
    }

    &__noZanNumber {
      font-size: .14rem;
      color: #A1A1B3;
    }

    &__name {
      color: #A1A1B3;
      font-size: .16rem;
      flex: 1;
    }

    &__zan {
      width: .2rem;
      height: .2rem;
      background: url(//coolcdn.igetcool.com/p/2020/1/385c66eb624bec858c305d2554d917355.png) no-repeat;
      background-size: 100% auto;
      margin-right: .01rem;
    }

    &__noZan {
      width: .2rem;
      height: .2rem;
      background: url(//coolcdn.igetcool.com/p/2020/1/3227314d50a7e18bc578d000a1baf7ffa.png) no-repeat;
      background-size: 100% auto;
      margin-right: .01rem;
    }

    &__avatr {
      width: .4rem;
      height: .4rem;
      margin-right: .15rem;

      img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        vertical-align: top;
      }
    }

    &__leaveMsgContent {
      padding-left: .2rem;
      padding-right: .2rem;
      display: flex;
      padding-top: .15rem;
      background-color: #fff;
    }

    &__messageNum {
      font-size: .14rem;
      color: #A1A1B3;
      display: flex;
      align-items: center;
    }

    &__noMessageText {
      color: #c2c2cc;
      text-align: center;
      font-size: .16rem;
    }

    &__noMessage {
      // padding-top: .4rem;
      padding-bottom: .4rem;
    }

    &__noMessageImg {
      width: 1.2rem;
      height: .75rem;
      display: block;
      margin: 0 auto;
      padding-top: .4rem;
    }

    &__leaveMsg {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding-right: .2rem;
    }

    &__messageArrow {
      width: .16rem;
      height: .16rem;
      background-image: url(//coolcdn.igetcool.com/p/2020/1/36b028bd2c3c55ae6d90facd901a691a7.png);
      background-repeat:  no-repeat;
      background-size: 100% auto;
    }

    &__knowText {
      color: #6D6D80;
      font-size: .15rem;
      padding-left: .2rem;
      padding-right: .2rem;
      line-height: .28rem;
      background-color: #fff;
    }

    &__grayColor {
      color: #A1A1B3;
      font-size: .14rem;
    }

    &__outline {
      height: .48rem;
      display: flex;
      align-items: center;
      padding-left: .2rem;
      color: #41414D;
      font-size: .18rem;
      flex: 1;
      background: #fff;
      font-weight: bold;
    }

    &__introAll {
      height: 1.26rem;
      position: absolute;
      bottom: -.01rem;
      width: 100%;
    }

    &__introLayer {
      height: .6rem;
      position: absolute;
      bottom: .66rem;
      left: 0;
      right: 0;
      background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
    }

    &__openAll {
      color: #A1A1B3;
      font-size: .14rem;
      padding-top: .16rem;
      padding-bottom: .3rem;
      text-align: center;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      background: #fff;
      height: .66rem;
      box-sizing: border-box;
    }

    &__introImage {
      width: 100%;
      display: block;
    }

    &__introText {
      color: #3D3D4D;
      font-size: .16rem;
      padding: 0rem 0.2rem;
    }

    &__introduction {
      position: relative;
    }

    &__introductionLimit {
      position: relative;
      height: 4.5rem;
      overflow: hidden;
    }

    &__introductionLimit2 {
      position: relative;
      max-height: 4.5rem;
      overflow: hidden;
      width: 3.35rem;
      margin: 0 auto;
      border-radius: .2rem;
      margin-bottom: .3rem;
    }

    &__introCover {
      position: relative;
      background: #fff;
      // padding-bottom: 1.1rem;
      // height: 3.24rem;
    }

    &__sort {
      width: .16rem;
      height: .16rem;
      color: #FF5F2E;
      mask: url(//coolcdn.igetcool.com/p/2020/1/640b36e0fb382fb3ad88ed2aabf7994c6.svg) no-repeat;
      -webkit-mask : url(//coolcdn.igetcool.com/p/2020/1/640b36e0fb382fb3ad88ed2aabf7994c6.svg) no-repeat;
      -webkit-mask-size : 100% auto;
      mask-size: 100% auto;
      fill: #FF5F2E;
      background-color: #FF5F2E;
    }

    &__order {
      width: .61rem;
      height: .3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background:rgba(248,248,250,1);
      border-radius: .15rem;
      color: #6D6D80;
      font-size: .12rem;
    }

    &__number {
      color: #A1A1B3;
      font-size: .12rem;
      flex: 1;
    }

    &__listTop {
      height: .5rem;
      align-items: center;
      padding-left: .2rem;
      padding-right: .2rem;
      display: flex;
      background: #fff;
    }

    &__tabCheck::after {
      content: '';
      background: #FF5E2E;
      width: .16rem;
      height: .05rem;
      border-radius: .03rem;
      position: absolute;
      bottom: -.1rem;
      left: 43%;
    }

    &__tabCheck {
      color: #41414d;
      position: relative;
    }

    &__tab {
      color: #6D6D80;
      font-size: .16rem;
      flex: 1;
      text-align: center;
    }

    &__tabList {
      display: flex;
      border-top-right-radius: .16rem;
      border-top-left-radius: .16rem;
      background: #fff;
      height: .54rem;
      align-items: center;
      position: sticky;
      top: .5rem;
      z-index: 9;
    }

    &__noBorder {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }

    &__studyNum {
      color: #fff;
      font-size: .12rem;
    }

    &__tips {
      border-radius: .1rem;
      border: .5px solid #fff;
      font-size: .12rem;
      padding: 0 .08rem;
      box-sizing: border-box;
      color: #fff;
      margin-right: .1rem;
      height: .2rem;
      line-height: .2rem;
    }

    &__tipsList {
      display: flex;
      margin-bottom: .16rem;
    }

    &__bannerContent {
      padding-top: .1rem;
      box-sizing: border-box;
      width: 2.17rem;
    }

    &__title {
      color: #fff;
      font-size: .18rem;
      margin-bottom: .06rem;
      font-weight: bold;
    }

    &__desc {
      font-size: .14rem;
      color: #fff;
      margin-bottom: .1rem;
    }

    &__banner {
      padding-top: .1rem;
      display: flex;
      padding-left: .2rem;
      padding-bottom: .2rem;
    }

    &__bannerImage {
      width: .98rem;
      height: 1.29rem;
      margin-right: .2rem;
      border-radius: .08rem;
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }

  .video__wrapper {
    line-height: 1px;
    video {
      width: 100vw;
      height: 56.25vw;
    }
  }
</style>
